import React from 'react';
import * as Sentry from '@sentry/react';

// NOTE: This isnt a real Suspense, but it was introduced to ease the process of possible switch to Suspense in future
// For now we're using 'isLoading' prop, which will be removed with React Suspense

export const Suspense = ({ fallback = null, isLoading, children }) => {
  return isLoading ? fallback : children;
};

// Error boundaries currently have to be classes.
export class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  // Forward errors to Sentry. No-op when SDK isn't initialized (local dev).
  // Without this, the 16 components using this boundary silently swallow errors.
  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setTag('errorBoundary', 'custom');
      scope.setContext('react', { componentStack: errorInfo && errorInfo.componentStack });
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.hasError || !this.props.children) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}
